//scrolling event starts //
  function smoothScroll(event, target) {
  // Check if the target is an ID link (e.g., #section)
  if (target.startsWith("#")) {
    event.preventDefault(); // Prevent default jump behavior

    // Find the target section
    const section = document.querySelector(target);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
// scrolling event ends //